var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewMaterial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1723_631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.47188 0.196903L0.971875 2.6344C0.3875 2.85315 0 3.41565 0 4.04065V11.075C0 11.6438 0.321875 12.1625 0.828125 12.4157L7.32812 15.6657C7.75 15.8782 8.24687 15.8782 8.66875 15.6657L15.1687 12.4157C15.6781 12.1625 15.9969 11.6407 15.9969 11.075V4.04065C15.9969 3.41565 15.6094 2.85628 15.025 2.63753L8.525 0.200028C8.1875 0.0687779 7.8125 0.0687779 7.47188 0.196903ZM8 2.13753L14 4.38753V4.4219L8 6.8594L2 4.4219V4.38753L8 2.13753ZM9 13.2625V8.6094L14 6.57815V10.7625L9 13.2625Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1723_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewMaterial);
export default __webpack_public_path__ + "static/media/icon--new-material.068b66a52f7896db458d7110a048ef4c.svg";
export { ForwardRef as ReactComponent };